import React, { useState } from 'react';
import { Column, Level, Table } from 'rbx';
import { Query } from 'react-apollo';
import { isNull } from 'lodash';
import gql from 'graphql-tag';
import SocialList from './SocialList';
import Search from './Search';
import {
  Input,
  Table as CustomTable,
  Loading,
} from '../../../components/elements';

const searchSocial = gql`
  query searchSocial($input: SearchInput) {
    search_social(input: $input) {
      social_aggregation {
        total_social_count {
          type
          count
        }
        total_social_per_object_id {
          total_social_count {
            type
            user {
              user_id
              time
            }
          }
        }
      }
    }
  }
`;

const Social = ({ place }) => {
  const [socialCount, setSocialCount] = useState({
    beenThere: 0,
    like_it: 0,
    bookmark: 0,
    share: 0,
  });
  const [filterType, setFilterType] = useState('been_there');
  const [user, setUser] = useState({
    beenThere: [],
    like_it: [],
    bookmark: [],
    share: [],
  });
  const social_filter = {
    object_id: place.place_id,
    object_type: 'PLACE',
  };
  // const [statusFilter, setStatusFilter] = useState('LIKE COUNT');
  return (
    <React.Fragment>
      <Level>
        <Column size={3}>
          <Input label="Been There" value={socialCount.beenThere} disabled />
        </Column>
        <Column size={3}>
          <Input label="Like It" value={socialCount.like_it} disabled />
        </Column>
        <Column size={3}>
          <Input label="Shares" value={socialCount.share} disabled />
        </Column>

        <Column size={3}>
          <Input label="Bookmarks" value={socialCount.bookmark} disabled />
        </Column>
      </Level>
      <Search filterType={filterType} setFilterType={setFilterType} />
      {/* <Pagination /> */}
      <CustomTable>
        <Table.Head>
          <Table.Row>
            <Table.Heading>
              <div>
                <span>
                  <i className="fas fa-sort-amount-down" /> User Display Name
                </span>
                <br />
                {/* <CustomInput /> */}
              </div>
            </Table.Heading>
            <Table.Heading>
              <div>
                <span>
                  <i className="fas fa-sort-amount-down" /> User Login
                </span>
                <br />
                {/* <CustomInput /> */}
              </div>
            </Table.Heading>
            <Table.Heading>
              <div>
                <span>
                  <i className="fas fa-sort-amount-down" /> Social Type
                </span>
                <br />
              </div>
            </Table.Heading>
            <Table.Heading>
              <div>
                <span>
                  <i className="fas fa-sort-amount-down" /> Created At
                </span>
                <br />
              </div>
            </Table.Heading>
            {/* <Table.Heading>
              <div>
                <span>
                  <i className="fas fa-sort-amount-down" /> Reviews
                </span>
              </div>
            </Table.Heading>
            <Table.Heading>
              <div>
                <span>
                  <i className="fas fa-sort-amount-down" /> Rating
                </span>
              </div>
            </Table.Heading>
            <Table.Heading>
              <div>
                <span>
                  <i className="fas fa-sort-amount-down" /> Photos
                </span>
              </div>
            </Table.Heading>

            <Table.Heading>
              <div>
                <span>
                  <i className="fas fa-sort-amount-down" /> Likes
                </span>
              </div>
            </Table.Heading>

            <Table.Heading>
              <div>
                <span>
                  <i className="fas fa-sort-amount-down" /> Flags
                </span>
              </div>
            </Table.Heading>

            <Table.Heading>
              <div>
                <span>
                  <i className="fas fa-sort-amount-down" /> Comments
                </span>
              </div>
            </Table.Heading> */}
          </Table.Row>
        </Table.Head>
        <Query
          query={searchSocial}
          variables={{ input: { filter: { social_filter } } }}
          fetchPolicy="network-only"
        >
          {({ data, loading, error }) => {
            if (loading) {
              return <Loading />;
            }
            if (error) {
              return 'error';
            }

            const { search_social } = data;
            if (isNull(search_social)) {
              return 'no data found';
            }

            return (
              <SocialList
                setSocialCount={setSocialCount}
                socialFilter={social_filter}
                users={user[filterType]}
                setUser={setUser}
                search_social={search_social}
              />
            );
          }}
        </Query>
      </CustomTable>
    </React.Fragment>
  );
};

export default Social;
